import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input, Button, Alert, Modal, Checkbox } from 'antd';
import SelectWithInstantFetch from 'components/form-elements/SelectWithInstantFetch';

const AddForm = ({ visible, error, submitting, handleCloseForm, handleSubmitForm }) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      handleSubmitForm(values);
    } catch (err) {
      console.error('Validation Failed:', err);
    }
  };

  return (
    <Modal
      width={768}
      open={visible}
      footer={false}
      title="Terminal Ekle"
      onCancel={handleCloseForm}
      destroyOnClose
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="branchId"
              label="Şube Numarası"
              initialValue=""
              style={{ display: 'none' }}
            >
              <Input disabled className="input__default" placeholder="Şube Numarası" />
            </Form.Item>
            <Form.Item
              name="serialNumber"
              label="Seri Numarası"
              rules={[{ required: true, message: 'Zorunlu Alan' }]}
            >
              <Input className="input__default" placeholder="Seri Numarası" />
            </Form.Item>
            <Form.Item
              name="sicilNumber"
              label="Sicil Numarası"
              rules={[{ required: true, message: 'Zorunlu Alan' }]}
            >
              <Input className="input__default" placeholder="Sicil Numarası" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="clientMarkaId" initialValue="0" style={{ display: 'none' }}>
              <Input />
            </Form.Item>
            <Form.Item
              name="clientModelId"
              label="Model"
              rules={[{ required: true, message: 'Zorunlu Alan' }]}
            >
              <SelectWithInstantFetch
                placeholder="Lütfen Model Seçiniz"
                labels={['Name']}
                path="client-model"
                showSearch
                dataIndex="ClientModelId"
              />
            </Form.Item>
            <Form.Item
              name="terminalVendorId"
              label="Satıcı"
              rules={[{ required: true, message: 'Zorunlu Alan' }]}
            >
              <SelectWithInstantFetch
                placeholder="Lütfen Satıcı Seçiniz"
                labels={['Name']}
                path="terminal-vendor"
                showSearch
                dataIndex="TerminalVendorId"
              />
            </Form.Item>
            <Form.Item
              name="clientId"
              label="Şube"
              rules={[{ required: true, message: 'Zorunlu Alan' }]}
            >
              <SelectWithInstantFetch
                placeholder="Lütfen Şube Seçiniz"
                labels={['Name']}
                path="client"
                showSearch
                dataIndex="ClientId"
              />
            </Form.Item>
            <Form.Item
              name="allowedFaturaForMerchant"
              valuePropName="checked"
              initialValue
              label="allowedFaturaForMerchant"
            >
              <Checkbox>allowedFaturaForMerchant</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        {error && (
          <Form.Item>
            <Alert message={error} type="error" showIcon />
          </Form.Item>
        )}
        <Form.Item className="text-align-right">
          <Button
            className="button button__outline mr-3"
            type="ghost"
            htmlType="button"
            disabled={submitting}
            onClick={handleCloseForm}
          >
            Vazgeç
          </Button>
          <Button
            className="button button__fill"
            type="primary"
            htmlType="submit"
            disabled={submitting}
            loading={submitting}
          >
            Kaydet
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  handleCloseForm: PropTypes.func.isRequired,
  handleSubmitForm: PropTypes.func.isRequired,
};

AddForm.defaultProps = {
  error: null,
};

export default AddForm;
